// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"460":"64635437","547":"64635437","6353":"64635437"}[chunkId] + ".chunk.css";
};